import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useProducts } from '../ProductContext';

const ProductDetails = () => {
  const { popular, latest } = useProducts();
  const { productId } = useParams();
  const allProducts = [...popular, ...latest];
  const product = allProducts.find((p) => p.id === parseInt(productId));

  if (!product) {
    return <div className="text-white bg-black p-10">Product not found</div>;
  }

  return (
    <div className="bg-black text-white p-10 min-h-screen flex flex-col items-center">
      <h1 className="text-2xl font-bold text-yellow-300 mb-6">{product.title}</h1>
      <div className="max-w-md w-full bg-gray-600 rounded-lg shadow shadow-green-600 p-4">
        {product.image ? (
          <img src={product.image} alt={product.title} className="w-full h-48 object-cover rounded" />
        ) : (
          <video controls className="w-full h-48">
            <source src={product.video} />
          </video>
        )}
        <div className="mt-4">
          <p className="text-lg font-semibold">Artist: {product.artist}</p>
          <p className="text-lg">Title: {product.title}</p>
          <p className="text-lg">Price: ${product.price}</p>
          <p className="text-lg">Status: {product.status === 'sold' ? 'Sold' : 'Available'}</p>
        </div>
        {product.audio && (
          <audio controls className="w-full mt-4">
            <source src={product.audio} />
          </audio>
        )}
        <div className="mt-4">
          <Link to={product.status === 'sold' ? '/Sold' : '/Buy'}>
            <button
              className={`w-full font-bold rounded-lg text-black px-4 py-2 ${
                product.status === 'sold' ? 'bg-orange-600' : 'bg-green-600'
              }`}
            >
              {product.status === 'sold' ? 'SOLD' : 'BUY'}
            </button>
          </Link>
        </div>
        <Link to="/Home" className="block mt-4 text-center text-yellow-300 hover:underline">
          Back to Collections
        </Link>
      </div>
    </div>
  );
};

export default ProductDetails;